import {
  Grid,
  Avatar,
  Box,
  Button,
  List,
  ListSubheader,
  ListItemAvatar,
  ListItem,
  ListItemText,
  Divider,
  Dialog,
} from "@mui/material";
import BottomMenu from "./BottomMenu";
import CookieIcon from "@mui/icons-material/Cookie";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import NotificationsIcon from "@mui/icons-material/Notifications";
import BusinessIcon from "@mui/icons-material/Business";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import LogoutIcon from "@mui/icons-material/Logout";
import { useHistory } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import Notification from "./Notification";
import ClearIcon from "@mui/icons-material/Clear";
import News from "./News";
import Center from "./Center";
import { loginState, configState } from "../lib/State"; // 로그인 (1)
import get_session from "../lib/get_session";
import Loading from "./Loading";
import BottomButton from "./BottomButton";
import HomeClassPoint from "./HomeClassPoint";
import EmailIcon from "@mui/icons-material/Email";
import WhatsNew from "./WhatsNew";
import axios from "axios";
import get_token from "../lib/get_token";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HomeHeartPoint from "./HomeHeartPoint";
import HomeCash from "./HomeCash";
import { ReactComponent as Coin } from "../assets/coin03.svg";
import { ReactComponent as NotificationIcon } from "../assets/notification.svg";
import { ReactComponent as WhatsNewIcon } from "../assets/whatsnew.svg";
import { ReactComponent as FrequencyIcon } from "../assets/calendar2.svg";
import { ReactComponent as HeartRateIcon } from "../assets/heartrate02.svg";
import FAQ from "./FAQ";
import { ReactComponent as PhoneIcon } from "../assets/phone.svg";
import { ReactComponent as PauseIcon } from "../assets/pause.svg";
import Refund from "./CouponRefund";
import Return from "./CouponReturn";
import ReservationTeacher from "./ReservationTeacher";
import get_cid from "../lib/get_cid";
import { ReactComponent as CancelIcon } from "../assets/cancel.svg";
import { ReactComponent as CalorieIcon } from "../assets/fire.svg";
import { ReactComponent as PushStar } from "../assets/push_star.svg";
import { ReactComponent as EtcCoin } from "../assets/etccoin.svg";
import Test from "./Test";
import Review from "./Review";
import HomeCalorie from "./HomeCalorie";
import MoreProgramResume from "./MoreProgramResume";
import MoreEtcPoint from "./MoreEtcPoint";
import get_center from "../lib/get_center";

function More() {
  const cid = get_cid();
  const center = get_center(cid);
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [openNotice, setOpenNotice] = useState(false);
  const history = useHistory();
  const token = get_token();

  const get_session = async () => {
    let result = await axios.post(configState.api + "/gympass/get_session", {
      token: token,
      cid: cid,
    });
    if (result.data.mcd !== "" && result.data.success === 1) {
      setLogin({ mcd: result.data.mcd, level: result.data.level });
    }
    setLoaded(true);
  };
  useEffect(() => {
    get_session();
  }, []);

  const clickOpenNotice = () => {
    setOpenNotice(true);
  };
  const clickCloseNotice = () => {
    setOpenNotice(false);
  };

  const [readyOpen, setReadyOpen] = useState(false);

  const logout = () => {
    Swal.fire({
      text: "로그아웃 하시겠습니까?",
      showCancelButton: true,
      confirmButtonText: "로그아웃",
      confirmButtonColor: "#0092a2",
      cancelButtonText: "취소",
      cancelButtonColor: "#FF0000",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        window.location.href = "/?cid=" + cid;
      }
    });
  };

  const quitMember = () => {
    Swal.fire({
      title: "정말로 탈퇴하시겠습니까?",
      html: "탈퇴시 모든 회원정보가 삭제되며 복구하실 수 없습니다. <br /> 또한 6개월간 동일한 휴대폰번호로 재가입이 불가능합니다.",
      showCancelButton: true,
      confirmButtonText: "회원탈퇴",
      confirmButtonColor: "#0092a2",
      cancelButtonText: "취소",
      cancelButtonColor: "#FF0000",
      input: "text",
      inputAttributes: {
        placeHolder: "휴대폰번호를 - 없이 입력해주세요.",
      },
    }).then(async (res) => {
      if (res.isConfirmed) {
        if (res.value.length !== 11) {
          Swal.fire("오류", "휴대폰번호를 올바르게 입력해주세요.");
          return;
        }
        let result = await axios.post(
          configState.api + "/gympass/quit_member",
          {
            token: token,
            cid: cid,
            level: login.level,
            mcd: login.mcd,
          },
        );
        if (result.data.success === 1) {
          localStorage.removeItem("token");
          Swal.fire("회원탈퇴 완료", "탈퇴 처리가 완료되었습니다.").then(
            (result) => {
              window.location.href = "/?cid=" + cid;
            },
          );
        } else {
          Swal.fire("오류가 발생 했습니다.", result.data.msg);
        }
      }
    });
  };

  // 출석포인트 팝업
  const homeClassRef = useRef();
  const classPointClick = () => {
    homeClassRef.current.open();
  };

  const WhatsNewRef = useRef();
  const WhatsNewClick = () => {
    WhatsNewRef.current.open();
  };

  const homeCashRef = useRef();
  const cashClick = () => {
    homeCashRef.current.open();
  };

  const homeCalorieRef = useRef();
  const caloriePointClick = () => {
    homeCalorieRef.current.open();
  };

  // 쿠폰 환불
  const goRefund = () => {
    history.push("/refund");
  };

  const goReturn = () => {
    history.push("/return");
  };

  return (
    <>
      {loaded ? (
        <Grid container height="100%" direction="column">
          <div
            className="absolute z-30 bg-white rounded-full bg-opacity-50 top-3 left-3"
            onClick={() => history.goBack()}
          >
            <img src="/img/back_button_black.png" alt="" />
          </div>
          {/* 출석포인트 팝업 */}
          <HomeClassPoint ref={homeClassRef} login={login} />

          {/* What's New 팝업 */}
          <WhatsNew ref={WhatsNewRef} login={login} />

          <HomeCash ref={homeCashRef} login={login} />

          <HomeCalorie ref={homeCalorieRef} login={login} />

          {/* 알림 */}
          <Dialog fullScreen open={openNotice} onClose={clickCloseNotice}>
            <Box
              sx={{
                width: "90%",
                textAlign: "left",
                padding: "30px 0 10px 10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <img
                src="/img/back_button_black.png"
                onClick={clickCloseNotice}
              />
              <Box
                sx={{
                  margin: "25px 0 0 10px",
                  fontSize: "22px",
                }}
              >
                알림
              </Box>
            </Box>
            <Divider />
            <Notification login={login}></Notification>
          </Dialog>

          <Box
            sx={{
              width: "90%",
              textAlign: "left",
              padding: "30px 0 10px 10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Box
              sx={{
                margin: "25px 0 0 10px",
                fontSize: "22px",
              }}
            >
              More
            </Box>
          </Box>
          <Divider />
          <Grid
            container
            flex="1"
            width="100%"
            direction="column"
            justifyContent="space-around"
            alignItems="left"
          >
            <Grid>
              <Box sx={{ height: "20px" }}></Box>
              <List>
                <ListSubheader sx={{ fontSize: "18px", fontWeight: "bold" }}>
                  소식
                </ListSubheader>

                <ListItem
                  sx={{ textAlign: "center" }}
                  onClick={clickOpenNotice}
                >
                  <ListItemAvatar>
                    <NotificationIcon width="24px" />
                  </ListItemAvatar>
                  <ListItemText sx={{ textAlign: "left" }}>알림</ListItemText>
                  <ListItemAvatar>
                    <ArrowRightIcon />
                  </ListItemAvatar>
                </ListItem>

                <ListItem sx={{ textAlign: "center" }} onClick={WhatsNewClick}>
                  <ListItemAvatar>
                    <WhatsNewIcon width="24px" />
                  </ListItemAvatar>
                  <ListItemText sx={{ textAlign: "left" }}>
                    What's New
                  </ListItemText>
                  <ListItemAvatar>
                    <ArrowRightIcon />
                  </ListItemAvatar>
                </ListItem>

                {login.mcd !== "" && (
                  <>
                    <Divider variant="middle" />
                    <ListSubheader
                      sx={{ fontSize: "18px", fontWeight: "bold" }}
                    >
                      서비스
                    </ListSubheader>

                    {login.level === "teacher" && (
                      <ReservationTeacher login={login} />
                    )}

                    {cid !== "CT25Z16161026.irtu8" && (
                      <ListItem
                        sx={{ textAlign: "center" }}
                        onClick={classPointClick}
                      >
                        <ListItemAvatar>
                          <FrequencyIcon width="24px" />
                        </ListItemAvatar>
                        <ListItemText sx={{ textAlign: "left" }}>
                          출석 프리퀀시
                        </ListItemText>
                        <ListItemAvatar>
                          <ArrowRightIcon />
                        </ListItemAvatar>
                      </ListItem>
                    )}

                    <HomeHeartPoint login={login} action="more">
                      <ListItem sx={{ textAlign: "center" }}>
                        <ListItemAvatar>
                          <HeartRateIcon width="24px" />
                        </ListItemAvatar>
                        <ListItemText sx={{ textAlign: "left" }}>
                          심박포인트
                        </ListItemText>
                        <ListItemAvatar>
                          <ArrowRightIcon />
                        </ListItemAvatar>
                      </ListItem>
                    </HomeHeartPoint>

                    <ListItem
                      sx={{ textAlign: "center" }}
                      onClick={caloriePointClick}
                    >
                      <ListItemAvatar>
                        <CalorieIcon width="24px" />
                      </ListItemAvatar>
                      <ListItemText sx={{ textAlign: "left" }}>
                        칼로리포인트
                      </ListItemText>
                      <ListItemAvatar>
                        <ArrowRightIcon />
                      </ListItemAvatar>
                    </ListItem>

                    <MoreEtcPoint>
                      <ListItem sx={{ textAlign: "center" }}>
                        <ListItemAvatar>
                          <EtcCoin width="24px" height="24px" />
                        </ListItemAvatar>
                        <ListItemText sx={{ textAlign: "left" }}>
                          기타포인트
                        </ListItemText>
                        <ListItemAvatar>
                          <ArrowRightIcon />
                        </ListItemAvatar>
                      </ListItem>
                    </MoreEtcPoint>

                    <ListItem sx={{ textAlign: "center" }} onClick={cashClick}>
                      <ListItemAvatar>
                        <Coin width="24px" height="24px" />
                      </ListItemAvatar>
                      <ListItemText sx={{ textAlign: "left" }}>
                        캐시내역
                      </ListItemText>
                      <ListItemAvatar>
                        <ArrowRightIcon />
                      </ListItemAvatar>
                    </ListItem>

                    <Refund login={login} />

                    <Return login={login} />

                    {/* <ListItem
                      sx={{ textAlign: "center" }}
                      onClick={cashClick}
                    >
                      <ListItemAvatar>
                        <PauseIcon width='24px' height='24px' />
                      </ListItemAvatar>
                      <ListItemText sx={{ textAlign: "left" }}>
                        쿠폰 정지 신청
                      </ListItemText>
                      <ListItemAvatar>
                        <ArrowRightIcon />
                      </ListItemAvatar>
                    </ListItem> */}
                    <Review login={login} />
                  </>
                )}
                {login.mcd !== "" && (
                  <ListItem sx={{ textAlign: "center" }} onClick={logout}>
                    <ListItemAvatar>
                      <LogoutIcon />
                    </ListItemAvatar>
                    <ListItemText sx={{ textAlign: "left" }}>
                      로그아웃
                    </ListItemText>
                    <ListItemAvatar>
                      <ArrowRightIcon />
                    </ListItemAvatar>
                  </ListItem>
                )}

                {login.mcd !== "" && (
                  <ListItem sx={{ textAlign: "center" }} onClick={quitMember}>
                    <ListItemAvatar>
                      <CancelIcon width="24px" height="24px" />
                    </ListItemAvatar>
                    <ListItemText sx={{ textAlign: "left" }}>
                      회원탈퇴
                    </ListItemText>
                    <ListItemAvatar>
                      <ArrowRightIcon />
                    </ListItemAvatar>
                  </ListItem>
                )}

                <Divider variant="middle" sx={{ textAliugn: "" }} />
                <ListSubheader sx={{ fontSize: "18px", fontWeight: "bold" }}>
                  센터소개
                </ListSubheader>
                <Center login={login} />

                <MoreProgramResume>
                  <ListItem sx={{ textAlign: "center" }}>
                    <ListItemAvatar>
                      <PushStar width="24px" height="24px" />
                    </ListItemAvatar>
                    <ListItemText sx={{ textAlign: "left" }}>
                      운동프로그램
                    </ListItemText>
                    <ListItemAvatar>
                      <ArrowRightIcon />
                    </ListItemAvatar>
                  </ListItem>
                </MoreProgramResume>

                <Divider variant="middle" sx={{ textAliugn: "" }} />
                <ListSubheader sx={{ fontSize: "18px", fontWeight: "bold" }}>
                  고객센터
                </ListSubheader>

                <FAQ />

                <ListItem
                  sx={{ textAlign: "center" }}
                  onClick={() =>
                    (window.location.href = `tel:${center.receipt.tel || "051-583-9645"}`)
                  }
                >
                  <ListItemAvatar>
                    <PhoneIcon width="24px" />
                  </ListItemAvatar>
                  <ListItemText sx={{ textAlign: "left" }}>
                    문의전화
                  </ListItemText>
                  <ListItemAvatar>
                    <ArrowRightIcon />
                  </ListItemAvatar>
                </ListItem>
              </List>
            </Grid>

            <Box sx={{ height: "100px" }}></Box>
          </Grid>
          <BottomButton login={login} loaded={loaded} />
          <BottomMenu active="more"></BottomMenu>
        </Grid>
      ) : (
        <Loading />
      )}
    </>
  );
}
export default More;
